import React from 'react';
import { useParams } from 'react-router-dom';
export function LeadDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  return <div data-id="element-2058">
      <div className="flex justify-between items-center mb-6" data-id="element-2059">
        <h1 className="text-2xl font-bold" data-id="element-2060">Lead Details</h1>
        <div className="space-x-2" data-id="element-2061">
          <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-2062">
            Edit
          </button>
          <button className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700" data-id="element-2063">
            Convert to Client
          </button>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-6" data-id="element-2064">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2065">
          <div data-id="element-2066">
            <h2 className="text-lg font-medium mb-4" data-id="element-2067">Contact Information</h2>
            <div className="space-y-3" data-id="element-2068">
              <div data-id="element-2069">
                <p className="text-sm text-neutral-500" data-id="element-2070">Name</p>
                <p className="font-medium" data-id="element-2071">John Doe</p>
              </div>
              <div data-id="element-2072">
                <p className="text-sm text-neutral-500" data-id="element-2073">Email</p>
                <p className="font-medium" data-id="element-2074">john.doe@example.com</p>
              </div>
              <div data-id="element-2075">
                <p className="text-sm text-neutral-500" data-id="element-2076">Phone</p>
                <p className="font-medium" data-id="element-2077">(555) 123-4567</p>
              </div>
              <div data-id="element-2078">
                <p className="text-sm text-neutral-500" data-id="element-2079">Address</p>
                <p className="font-medium" data-id="element-2080">123 Main St, Anytown, CA 12345</p>
              </div>
            </div>
          </div>
          <div data-id="element-2081">
            <h2 className="text-lg font-medium mb-4" data-id="element-2082">Lead Information</h2>
            <div className="space-y-3" data-id="element-2083">
              <div data-id="element-2084">
                <p className="text-sm text-neutral-500" data-id="element-2085">Status</p>
                <p className="font-medium" data-id="element-2086">New</p>
              </div>
              <div data-id="element-2087">
                <p className="text-sm text-neutral-500" data-id="element-2088">Source</p>
                <p className="font-medium" data-id="element-2089">Website</p>
              </div>
              <div data-id="element-2090">
                <p className="text-sm text-neutral-500" data-id="element-2091">Referral Partner</p>
                <p className="font-medium" data-id="element-2092">ABC Insurance Agency</p>
              </div>
              <div data-id="element-2093">
                <p className="text-sm text-neutral-500" data-id="element-2094">Goals</p>
                <p className="font-medium" data-id="element-2095">
                  Reduce monthly premium, Increase coverage
                </p>
              </div>
              <div data-id="element-2096">
                <p className="text-sm text-neutral-500" data-id="element-2097">Ratios</p>
                <p className="font-medium" data-id="element-2098">Debt-to-Income: 32%, LTV: 75%</p>
              </div>
              <div data-id="element-2099">
                <p className="text-sm text-neutral-500" data-id="element-2100">Created Date</p>
                <p className="font-medium" data-id="element-2101">Jan 15, 2023</p>
              </div>
              <div data-id="element-2102">
                <p className="text-sm text-neutral-500" data-id="element-2103">Assigned To</p>
                <p className="font-medium" data-id="element-2104">Jane Smith</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}